import { useMutation } from "@tanstack/react-query";
import { Button, Form, Input, InputNumber, message, Modal, Select } from "antd";
import axios from "axios";
import { forwardRef, useImperativeHandle, useState } from "react";
import { hostname } from "../hooks/useEndeavour";

const AddCampaignRuleModal = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const openModal = () => {
    setVisible(true);
  };

  const closeModal = () => {
    setVisible(false);
    form.resetFields();
  };

  useImperativeHandle(ref, () => ({
    openModal,
    closeModal,
  }));

  const submit = useMutation({
    mutationFn: (data) => {
      return axios
        .post(`${hostname}/pa-alliance/campaign/rule`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          if (res.status !== 200) {
            message.error("Add Failed");
          }
          message.success("Campaign Rule Added");
          setLoading(false);
          closeModal();
          props.onChange();
        })
        .catch((error) => {
          message.error("Add Failed");
          setLoading(false);
        });
    },
  });

  const onSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      submit.mutate(values);
    });
  };

  return (
    <Modal title="Add Campaign Rule" open={visible} onCancel={closeModal} footer={null}>
      <Form layout="vertical" form={form} onFinish={onSubmit}>
        <Form.Item label="Name" name="name" rules={[{ required: true, message: "Please input the name!" }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Type" name="type" rules={[{ required: true, message: "Please select the type!" }]}>
          <Select
            options={[
              { value: "inactivity_user", label: "Inactivity User" },
              { value: "injection", label: "Injection" },
            ]}
          />
        </Form.Item>

        <Form.Item label="Operator" name="operator" rules={[{ required: true, message: "Please select the operator!" }]}>
          <Select
            options={[
              { value: "gt", label: "Greater Than" },
              { value: "gte", label: "Greater Than or Equal" },
              { value: "eq", label: "Equal" },
              { value: "lte", label: "Less Than or Equal" },
              { value: "lt", label: "Less Than" },
            ]}
          />
        </Form.Item>

        <Form.Item label="Condition Value" name="condition_value" rules={[{ required: true, message: "Please input the condition value!" }]}>
          <Input />
        </Form.Item>

        <Form.Item label="Entry" name="entry" rules={[{ required: true, message: "Please input the entry!" }]}>
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
});

export default AddCampaignRuleModal;
